import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Share2 } from "lucide-react";
import { DetailHeader } from "./DetailHeader";
import { DetailStats } from "./DetailStats";
import { DetailSupplier } from "./DetailSupplier";
import { DetailCreator } from "./DetailCreator";
import { DetailPayment } from "./DetailPayment";
import { DetailItems } from "./DetailItems";
import { DetailApproval } from "./DetailApproval";
import { DetailAttachment } from "./DetailAttachment";
import { DetailFooter } from "./DetailFooter";
import { ShareLinkModal } from "./ShareLinkModal";
import { PurchaseActions } from "../PurchaseActions";
import { InvoiceUploadInput, useInvoiceUpload } from "../InvoiceUpload";

const SHARE_STATES = ["sent", "partially_received", "received"];

// صفحة تفاصيل أمر الشراء — ارتفاع كامل، رأس وذيل مثبتان، مشاركة رابط الاعتماد + مرفقات.
export const PODetailView = ({ doc, backTo, onRun, busy, onDone, extra }) => {
  const { t } = useTranslation();
  const [shareOpen, setShareOpen] = useState(false);
  const uploader = useInvoiceUpload(() => onDone?.());
  const canShare = doc.doc_type === "purchase_order" && SHARE_STATES.includes(doc.state);
  const showAttach = doc.doc_type === "purchase_order";
  const wrappedRun = async (action) => {
    const ok = await onRun?.(action);
    if (ok && action === "send") setShareOpen(true);
  };
  return (
    <div className="flex h-[100dvh] w-full flex-col overflow-hidden bg-muted/30"
         data-testid="po-detail-view">
      <DetailHeader number={doc.number} backTo={backTo} />
      <main className="flex-1 overflow-y-auto overscroll-contain px-4 py-5 sm:px-8 lg:px-12 2xl:px-24">
        <div className="mx-auto w-full max-w-6xl">
          <DetailStats doc={doc} />
          <DetailSupplier doc={doc} />
          <DetailCreator doc={doc} />
          {doc.doc_type !== "requisition" ? <DetailPayment doc={doc} /> : null}
          <DetailItems doc={doc} />
          <DetailApproval doc={doc} onDone={onDone} />
          {showAttach ? (
            <DetailAttachment doc={doc} onPick={uploader.pick} busy={uploader.busy} />
          ) : null}
          {onRun || canShare ? (
            <div className="mb-4 rounded-2xl border border-border/60 bg-background p-4 shadow-neu-sm"
                 data-testid="section-order-actions" dir="rtl">
              <p className="mb-3 text-sm font-bold text-primary">
                {t("purchases.actions.sectionTitle")}
              </p>
              <div className="flex flex-wrap items-center gap-2">
                {onRun ? <PurchaseActions doc={doc} onRun={wrappedRun} busy={busy} /> : null}
                {canShare ? (
                  <button data-testid="action-share-link" onClick={() => setShareOpen(true)}
                          className="inline-flex items-center gap-2 rounded-2xl border border-border/70 bg-background px-3 py-2 text-xs font-semibold text-primary shadow-neu-sm hover:brightness-110">
                    <Share2 className="h-3.5 w-3.5" /> {t("purchases.share.button")}
                  </button>
                ) : null}
              </div>
            </div>
          ) : null}
          {extra}
        </div>
      </main>
      <DetailFooter doc={doc} backTo={backTo} />
      <ShareLinkModal open={shareOpen} onClose={() => setShareOpen(false)}
                      doc={doc} onDone={onDone} />
      <InvoiceUploadInput inputRef={uploader.ref}
                          onChange={(e) => uploader.change(e, doc.id)} />
    </div>
  );
};
